export const httpRetryInterval = 3000;
export const backOfficeUrl = 'https://paytick.sn';
export const apiUrl = 'https://paytick.sn/api';



